module.exports = __webpack_public_path__ + "img/top.5ee72e15.jpg";